export default {
  city(state) {
    return state.city
  },
  cities(state) {
    return state.cities
  },
  cityFilters(state) {
    return state.cityFilters
  },
  cityByFilteredDistrict(state) {
    return state.cityByFilteredDistrict
  },
  getCityById: state => cityId => state.cities.find(city => city.id === cityId),
}
